import React from 'react';
import './ContentPolicy.css';
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const ContentPolicy = () => {
  return (
     <>
      <Navbar />
        <PageHeader 
                  title="Content Policy" 
                  crumbs={[{ label: 'Home', href: '/' }, { label: 'Content Policy' }]} 
                />
    <div className="tm-main-container">
      {/* Breadcrumb Header */}
     

      {/* Main Title Section */}
      <section className="tm-hero-section">
      
       
        <p className="tm-intro-text">
          This Web Content policy sets the Institute's standard for:
        </p>
      </section>

      {/* Top Standards Section */}
      <section className="tm-standards-grid">
        <div className="tm-standard-item">
          <div className="tm-circle-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line><path d="M12 7v4"></path><path d="M12 11l2-2"></path></svg>
          </div>
          <p>Establishing acceptable use of those Web pages,</p>
        </div>

        <div className="tm-standard-item">
          <div className="tm-circle-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
          </div>
          <p>Enhancing the Institute's mission by clarifying responsibilities of Web content authors, and</p>
        </div>

        <div className="tm-standard-item">
          <div className="tm-circle-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M9 15l2 2 4-4"></path></svg>
          </div>
          <p>Requiring accurate, useful and attractive presentations of information on those Web pages.</p>
        </div>
      </section>

      {/* Bottom Detailed Cards */}
      <section className="tm-details-grid">
        <div className="tm-info-card">
          <div className="tm-card-circle">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
          </div>
          <div className="tm-card-divider"></div>
          <p className="tm-card-text">The Institute website, portal, and webpages are owned by the Institute and intended solely for Institute-related purposes. They may be used to post Institute activities and departmental accomplishments.</p>
        </div>

        <div className="tm-info-card">
          <div className="tm-card-circle">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
          </div>
          <div className="tm-card-divider"></div>
          <p className="tm-card-text">The main page of each site or subsite must have the following information readily accessible: A prominent link to the referring webpage, whether from the portal or the external website.</p>
        </div>

        <div className="tm-info-card">
          <div className="tm-card-circle">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line><circle cx="12" cy="10" r="3"></circle></svg>
          </div>
          <div className="tm-card-divider"></div>
          <p className="tm-card-text">The IT department makes decisions on the format and organization of information on the website. All requests for adding departmental information should be sent to the IT department.</p>
        </div>

        <div className="tm-info-card tm-contact-card">
          <div className="tm-card-circle">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
          </div>
          <div className="tm-card-divider"></div>
          <p className="tm-card-text tm-center-text">For further information please contact IT department at</p>
          <a href="mailto:it@thakureducation.org" className="tm-email-button">it@thakureducation.org</a>
        </div>
      </section>
    </div>
          <Footer />
    </>
  );
};

export default ContentPolicy;